<template>
    <div class="population-selector-component">
        <div class="preset-column">
            <input-container
                v-model="fieldConfig[1]"
                :showTooltip="true"
            ></input-container>
            <input-container id="disabled"
                v-model="fieldConfig[3]"
                :showTooltip="true"
            ></input-container>
        </div>
        <div class="basis-column">
            <div class="label">Population Information <span class="field-info" v-tooltip="'Population description and parameters'"></span></div>
            <div class="population-disclaimer">This population was derived from a <b>single heart anatomy</b>, results can provide valuable trend information and insights but they will not fully represent the diversity of real-world populations.</div>
            <div class="info-box">
                <div class="descriptors">
                    <div class="item" v-for="descriptor in populationDescriptors"> {{ descriptor }}</div>
                </div>
                <div class="infos">
                    <div class="item" v-for="info,i in populationsInfo[selectedPopulation]">{{ info }}</div>
                </div>
            </div>
        </div>
        <div class="size-column">
            <div class="label">Population size <span class="field-info" v-tooltip="'Amount of subjects to be generated'"></span></div>
            <sub-field-list-input-container class="size-box"
                :fieldConfig="fieldConfig[2]"
                :showLabel="false"
                :showTooltip="true"
            ></sub-field-list-input-container>
        </div>
    </div>
</template>

<script>
import MultiSelectComponent from '@/components/MultiSelectComponent'
import ToggleInput from '@/components/inputs/frontendInputs/ToggleInput'
import InputContainer from '@/components/inputs/InputContainer'
import SubFieldListInputContainer from '@/components/inputs/SubFieldListInputContainer'


export default {
  name: 'PopulationSelectorComponent',
  components: { MultiSelectComponent, ToggleInput, InputContainer, SubFieldListInputContainer },
  props: {
    fieldConfig: Array
  },
  model: {
    prop: 'fieldConfig',
    event: 'change'
},
  data() {
    return {
      error: '',
      populationDescriptors : ['Phenotype', 'Female ratio', 'Anatomy count', 'BMI class.',  'Scar'],
      populationsInfo: {
        'T1.0': ['Healthy', '0.5', '1', 'Underweight',  'No'],
        'T1.1': ['Healthy', '0.5', '1', 'Normal', 'No'],
      },
    }
  },
  computed: {
    selectedPopulation() {
        return this.fieldConfig[1].value
    },
  },
}
</script>

<style lang="stylus">
.population-selector-component
    display: flex
    flex-direction: row
    justify-content: space-between

    #disabled
        opacity: 0.4
        pointer-events: none

    .label
        color: $shuttle-gray
        display: flex
        align-items: center
        m-font-size(12, 14)
        margin-bottom: 5px
        .field-info
            margin-left: 5px
            m-icon('info', 14)
    .preset-column
        width: 20%
        flex-grow: 0
    .basis-column
        width: 40%
        padding-top: 5px
        .info-box
            margin-top: 10px
            background-color: white
            padding: 10px
            margin-bottom: 20px
            m-font-size(12,14)
            color: $cloud-burst
            border-radius: 5px
            box-shadow: 5px 5px 20px rgba($lynch, 0.25)
            display: flex
            flex-direction: row
            .descriptors
                font-weight: bold
                margin-right: 30px
            .item
                padding-bottom: 5px
        .population-disclaimer
            m-font-size(12,14)
            color: $cloud-burst
    .size-column
        width: 20%
        padding-top: 5px
        .size-box
            margin-top: 10px
            margin-bottom: 22px
</style>